/* Yakınında — tema betiği
   Bağlama iki kez yapılır: ilk yükleme ve tema editörü bölüm yeniden
   render ettiğinde (shopify:section:load). İkincisi olmazsa merchant
   editörde bir ayarı değiştirdiğinde bölüm ölü görünür. */

(() => {
  'use strict';

  const money = (cents) =>
    (cents / 100).toLocaleString(document.documentElement.lang || 'tr-TR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  /* --- Sepet ------------------------------------------------------------ */

  const CartDrawer = {
    el: () => document.querySelector('[data-cart-drawer]'),

    open() {
      const d = this.el();
      if (!d) return;
      d.hidden = false;
      // Zorunlu reflow, geçişin başlangıç durumunu kaydettirir.
      // requestAnimationFrame kullanılırsa sekme arka plandayken
      // hiç çalışmaz ve panel ekran dışında kalır.
      void d.offsetWidth;
      d.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      // Arka plan klavye ve ekran okuyucudan cikarilir; aksi halde Tab
      // panelden cikip gorunmeyen baglantilarda geziniyordu.
      document.querySelectorAll('body > header, body > main, body > footer').forEach((el) => {
        el.inert = true;
      });

      d.querySelector('[data-drawer-close]')?.focus();
    },

    close() {
      const d = this.el();
      if (!d) return;
      d.classList.remove('is-open');
      document.body.style.overflow = '';
      document.querySelectorAll('body > header, body > main, body > footer').forEach((el) => {
        el.inert = false;
      });
      document.querySelector('[data-cart-open]')?.focus();
      setTimeout(() => {
        d.hidden = true;
      }, 200);
    },

    // Panel icinde Tab dongusu
    trap(e) {
      const d = this.el();
      if (!d || d.hidden || e.key !== 'Tab') return;
      const f = [...d.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])')].filter(
        (el) => el.offsetParent !== null
      );
      if (!f.length) return;
      const first = f[0];
      const last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    },

    async refresh() {
      const d = this.el();
      if (!d) return;
      const res = await fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`);
      if (!res.ok) return;
      const html = await res.text();
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer]');
      if (!fresh) return;
      d.innerHTML = fresh.innerHTML;
      // Icerik degistigi icin panel ici olaylar yeniden baglanir
      initQty(d);
      d.querySelectorAll('[data-drawer-close], [data-drawer-overlay]').forEach((b) => {
        if (b.dataset.bound) return;
        b.dataset.bound = '1';
        b.addEventListener('click', () => CartDrawer.close());
      });
    },
  };

  async function updateCartCount() {
    const res = await fetch(`${window.Shopify.routes.root}cart.js`);
    if (!res.ok) return null;
    const cart = await res.json();
    document.querySelectorAll('[data-cart-count]').forEach((n) => {
      n.textContent = cart.item_count;
      n.hidden = cart.item_count === 0;
    });
    return cart;
  }

  async function addToCart(form, button) {
    /* Ürün sayfasında buton bir span sarıyor; doğrudan button.textContent
       yazmak o span'i siler ve varyant güncellemesi bir daha tutmaz.
       Ayrı bir mesaj alanı varsa geri bildirim oraya gider, böylece
       buton etiketi hiç oynamaz. */
    const label = form.querySelector('[data-add-text]') || button;
    const msg = form.querySelector('[data-form-msg]');
    const scope = form.closest('[data-pdp]');
    const original = label.textContent;
    button.disabled = true;

    const say = (text, tone) => {
      if (!msg) {
        label.textContent = text;
        return;
      }
      msg.textContent = text;
      msg.dataset.tone = tone;
      msg.hidden = false;
    };

    const reset = (delay) =>
      setTimeout(() => {
        if (!msg) label.textContent = original;
        else msg.hidden = true;
        button.disabled = false;
      }, delay);

    try {
      const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Ürün sepete eklenemedi.');
      }

      await updateCartCount();

      if (document.body.dataset.cartType === 'drawer') {
        await CartDrawer.refresh();
        CartDrawer.open();
      } else {
        window.location.href = `${window.Shopify.routes.root}cart`;
        return;
      }

      say(scope?.dataset.i18nAdded || '✓', 'ok');
      reset(1200);
    } catch (e) {
      say(e.message.slice(0, 80), 'error');
      reset(2500);
    }
  }



/* --- Favori listesi (tarayıcıda saklanır) ------------------------------ */

const WISH_KEY = 'yk-wishlist';

const Store = {
  read(key) {
    try {
      return JSON.parse(localStorage.getItem(key) || '[]');
    } catch {
      return [];
    }
  },
  write(key, list) {
    localStorage.setItem(key, JSON.stringify(list));
  },
};

/* Favoriye eklenen ürünün bilgileri de yazılır; favoriler sayfası
   böylece istek beklemeden çizilir. Temanın ilk sürümü yalnızca
   kimlik saklıyordu, o kayıtlardan kart üretilemediği için elenir. */
const Wishlist = {
  all() {
    return Store.read(WISH_KEY).filter((p) => p && typeof p === 'object' && p.handle);
  },
  save(list) {
    Store.write(WISH_KEY, list);
  },
  toggle(item) {
    const list = Wishlist.all();
    const i = list.findIndex((p) => String(p.id) === String(item.id));
    if (i === -1) list.unshift(item);
    else list.splice(i, 1);
    Wishlist.save(list);
    return i === -1;
  },
  remove(id) {
    Wishlist.save(Wishlist.all().filter((p) => String(p.id) !== String(id)));
  },
  clear() {
    Wishlist.save([]);
  },
};

function syncLists() {
  const wish = Wishlist.all();
  const ids = new Set(wish.map((p) => String(p.id)));

  document.querySelectorAll('[data-wishlist]').forEach((b) => {
    b.setAttribute('aria-pressed', String(ids.has(b.dataset.wishlist)));
  });
  document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
    el.textContent = wish.length;
    el.hidden = wish.length === 0;
  });
}

/* --- Favoriler sayfası -------------------------------------------------- */

const esc = (s) =>
  String(s ?? '').replace(
    /[&<>"']/g,
    (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]
  );

/* Fiyat kuruş olarak saklanır; mağazanın para biçimi olmadan doğru
   yazılamaz, bu yüzden biçim bölümün data alanından okunur. */
function formatMoney(cents, format) {
  const amount = Number(cents) || 0;
  const token = /\{\{\s*(\w+)\s*\}\}/;
  const name = (format || '').match(token);
  if (!name) return money(amount);

  const build = (thousands, decimal, decimals) => {
    const [whole, frac] = (amount / 100).toFixed(decimals).split('.');
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return frac ? grouped + decimal + frac : grouped;
  };

  let value;
  switch (name[1]) {
    case 'amount_no_decimals':
      value = build(',', '.', 0);
      break;
    case 'amount_with_comma_separator':
      value = build('.', ',', 2);
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = build('.', ',', 0);
      break;
    case 'amount_with_apostrophe_separator':
      value = build("'", '.', 2);
      break;
    default:
      value = build(',', '.', 2);
  }
  return format.replace(token, value);
}

function wishlistCard(p, ctx) {
  const image = p.image
    ? `<img class="card__img" src="${esc(p.image)}" alt="${esc(p.title)}" loading="lazy" width="400" height="400">`
    : '';
  const soldOut =
    p.available === false
      ? `<div class="card__flags"><span class="badge badge--soft">${esc(ctx.soldOut)}</span></div>`
      : '';

  return `
    <article class="card" data-product-id="${esc(p.id)}">
      <a class="card__link" href="${esc(p.url)}">
        <div class="card__media">${image}${soldOut}</div>
        <div class="card__body">
          ${p.vendor ? `<span class="card__vendor">${esc(p.vendor)}</span>` : ''}
          <h3 class="card__title">${esc(p.title)}</h3>
          <span class="card__prices">
            <span class="card__price">${esc(formatMoney(p.price, ctx.moneyFormat))}</span>
          </span>
        </div>
      </a>
      <div class="card__tools">
        <button
          class="tool"
          type="button"
          data-wishlist-remove="${esc(p.id)}"
          aria-pressed="true"
          aria-label="${esc(ctx.remove)}: ${esc(p.title)}"
        >${ctx.icon}</button>
      </div>
    </article>`;
}

function renderWishlist() {
  const section = document.querySelector('[data-wishlist-section]');
  if (!section) return;

  const host = section.querySelector('[data-wishlist-host]');
  if (!host) return;

  const list = Wishlist.all();
  const ctx = {
    moneyFormat: section.dataset.moneyFormat,
    remove: section.dataset.labelRemove,
    soldOut: section.dataset.labelSoldOut,
    icon: section.querySelector('[data-wishlist-icon]')?.innerHTML || '',
  };

  host.innerHTML = list.map((p) => wishlistCard(p, ctx)).join('');
  host.hidden = list.length === 0;
  section.querySelectorAll('[data-wishlist-empty]').forEach((el) => {
    el.hidden = list.length > 0;
  });
  section.querySelectorAll('[data-wishlist-clear]').forEach((el) => {
    el.hidden = list.length === 0;
  });

  bind(host);
}

/* Kayıt, ürün favoriye eklendiği andan kalmadır: fiyat ve stok değişmiş,
   ürün yayından kalkmış olabilir. Sayfa açılışında tazelenir; artık
   bulunamayan ürünler listeden düşer, böylece kırık bağlantı kalmaz. */
async function refreshWishlist() {
  if (!document.querySelector('[data-wishlist-section]')) return;

  const list = Wishlist.all();
  if (!list.length) return;

  const root = window.Shopify.routes.root;
  const fresh = await Promise.all(
    list.map(async (p) => {
      try {
        const res = await fetch(`${root}products/${encodeURIComponent(p.handle)}.js`);
        if (res.status === 404) return null;
        if (!res.ok) return p;
        const d = await res.json();
        return {
          ...p,
          title: d.title,
          vendor: d.vendor,
          price: d.price,
          available: d.available,
          image: d.featured_image || p.image,
          url: `${root}products/${d.handle}`,
        };
      } catch {
        // Ağ hatasında eldeki kayıt korunur; ürün silinmiş sayılmaz.
        return p;
      }
    })
  );

  const kept = fresh.filter(Boolean);
  if (JSON.stringify(kept) === JSON.stringify(list)) return;
  Wishlist.save(kept);
  syncLists();
  renderWishlist();
}

/* --- Son gezilen ürünler ----------------------------------------------- */

function recordRecentlyViewed() {
  const el = document.querySelector('[data-product-json]');
  if (!el) return;
  let p;
  try {
    p = JSON.parse(el.textContent);
  } catch {
    return;
  }
  const list = Store.read('yk-recent').filter((x) => x.id !== p.id);
  list.unshift(p);
  Store.write('yk-recent', list.slice(0, 12));
}

function renderRecentlyViewed() {
  const host = document.querySelector('[data-recent-host]');
  if (!host) return;
  const list = Store.read('yk-recent');
  const section = host.closest('[data-recent-section]');
  if (!list.length) {
    if (section) section.hidden = true;
    return;
  }
  if (section) section.hidden = false;
  host.innerHTML = list
    .map(
      (p) => `
      <article class="card">
        <a class="card__link" href="${p.url}">
          <div class="card__media">
            <img class="card__img" src="${p.image}" alt="${p.title.replace(/"/g, '&quot;')}" loading="lazy" width="400" height="400">
          </div>
          <div class="card__body">
            ${p.vendor ? `<span class="card__vendor">${p.vendor}</span>` : ''}
            <h3 class="card__title">${p.title}</h3>
            <span class="card__prices"><span class="card__price">${p.price}</span></span>
          </div>
        </a>
      </article>`
    )
    .join('');
}


/* --- Carousel ----------------------------------------------------------- */

/* Oklar yalnızca içerik taştığında görünür ve uçlara gelindiğinde söner.
   İçeriğin bir kısmı JS ile sonradan doluyor (öneriler, son gezilenler);
   bu yüzden ölçüm hem boyut hem de çocuk değişiminde tekrarlanır —
   aksi halde ilk ölçüm boş listede yapılıp ok hiç çıkmıyor. */
function initCarousel(root) {
  const track = root.querySelector('[data-carousel-track]');
  if (!track) return;

  const prev = root.querySelector('[data-carousel-btn="prev"]');
  const next = root.querySelector('[data-carousel-btn="next"]');

  const update = () => {
    const max = track.scrollWidth - track.clientWidth;
    root.toggleAttribute('data-overflow', max > 1);
    if (prev) prev.disabled = track.scrollLeft <= 1;
    if (next) next.disabled = track.scrollLeft >= max - 1;
  };

  // Bir ekran dolusunun biraz altı: kullanıcı nerede kaldığını görsün
  const step = () => Math.max(track.clientWidth * 0.8, 200);

  prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
  next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));

  track.addEventListener('scroll', update, { passive: true });
  new ResizeObserver(update).observe(track);
  new MutationObserver(update).observe(track, { childList: true });
  update();
}

/* --- Benzer ürünler ----------------------------------------------------- */

/* Öneriler ürüne göre değiştiği için sayfayla birlikte basılmaz; bölüm
   boş gelir, burada doldurulur. Boş yanıt gelirse bölüm boş kalır ve
   kendi başlığını da göstermez. */
function initRecommendations(el) {
  const url = el.dataset.url;
  if (!url) return;

  fetch(url)
    .then((res) => (res.ok ? res.text() : Promise.reject(new Error('recommendations'))))
    .then((html) => {
      const fresh = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('[data-recommendations]');
      if (!fresh || !fresh.innerHTML.trim()) return;
      el.innerHTML = fresh.innerHTML;
      // Yeni kartlardaki favori butonu ve hızlı sepete ekleme bağlanmalı
      bind(el);
      syncLists();
    })
    .catch(() => {});
}

/* --- Teslimat vaadi ---------------------------------------------------- */

/* Kesim saati her zaman Türkiye saatine göre değerlendirilir, ziyaretçinin
   kendi saat dilimine göre değil. Liquid tarafındaki metin tam sayfa
   önbelleğinde bayatlayabildiği için doğrusu burada yazılır. */

function trHour() {
  try {
    const value = new Intl.DateTimeFormat('tr-TR', {
      timeZone: 'Europe/Istanbul',
      hour: '2-digit',
      hourCycle: 'h23',
    }).format(new Date());
    const hour = parseInt(value, 10);
    if (Number.isNaN(hour)) return null;
    return hour === 24 ? 0 : hour; // bazı motorlar gece yarısını 24 verir
  } catch {
    return null;
  }
}

function refreshDeliveryLabels(root) {
  const nodes = root.querySelectorAll('[data-delivery-label]');
  if (!nodes.length) return;
  const hour = trHour();
  if (hour === null) return; // Liquid yedeği yerinde kalsın

  nodes.forEach((el) => {
    const cutoff = parseInt(el.dataset.cutoff, 10);
    if (Number.isNaN(cutoff)) return;
    const text = hour < cutoff ? el.dataset.today : el.dataset.tomorrow;
    const slot = el.querySelector('[data-delivery-text]');
    if (slot && text) slot.textContent = text;
  });
}

/* --- Hero slider ------------------------------------------------------- */

const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function initHero(root) {
  const track = root.querySelector('[data-hero-track]');
  const slides = [...root.querySelectorAll('[data-hero-slide]')];
  const dots = [...root.querySelectorAll('[data-hero-dot]')];
  if (!track || slides.length < 2) return;

  let timer = null;
  const interval = (Number(root.dataset.interval) || 6) * 1000;
  const wantsAutoplay = root.dataset.autoplay === 'true' && !reduceMotion();

  const index = () => Math.round(track.scrollLeft / track.clientWidth);

  const goTo = (i) => {
    const n = (i + slides.length) % slides.length;
    track.scrollTo({ left: n * track.clientWidth, behavior: reduceMotion() ? 'auto' : 'smooth' });
  };

  const paint = () => {
    const cur = index();
    dots.forEach((d, i) => d.setAttribute('aria-selected', String(i === cur)));
    slides.forEach((s, i) => {
      // Ekran disindaki slaytlar klavye sirasindan cikarilir
      s.querySelectorAll('a, button').forEach((el) => {
        el.tabIndex = i === cur ? 0 : -1;
      });
    });
  };

  const stop = () => {
    if (timer) clearInterval(timer);
    timer = null;
  };

  const start = () => {
    if (!wantsAutoplay) return;
    stop();
    timer = setInterval(() => goTo(index() + 1), interval);
  };

  root.querySelector('[data-hero-prev]')?.addEventListener('click', () => {
    goTo(index() - 1);
    start();
  });
  root.querySelector('[data-hero-next]')?.addEventListener('click', () => {
    goTo(index() + 1);
    start();
  });
  dots.forEach((d) =>
    d.addEventListener('click', () => {
      goTo(Number(d.dataset.heroDot));
      start();
    })
  );

  let raf;
  track.addEventListener('scroll', () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(paint);
  });

  root.addEventListener('mouseenter', stop);
  root.addEventListener('mouseleave', start);
  root.addEventListener('focusin', stop);
  root.addEventListener('focusout', start);
  document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));

  root.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') { goTo(index() - 1); start(); }
    if (e.key === 'ArrowRight') { goTo(index() + 1); start(); }
  });

  paint();
  start();
  root.dataset.heroReady = '1';
}

/* Tema editorunde bir slayt secilince ona kaydir ve otomatik gecisi durdur */
document.addEventListener('shopify:block:select', (e) => {
  const slide = e.target.closest('[data-hero-slide]');
  const root = e.target.closest('[data-hero]');
  if (!slide || !root) return;
  const track = root.querySelector('[data-hero-track]');
  const i = [...root.querySelectorAll('[data-hero-slide]')].indexOf(slide);
  track?.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  root.dataset.autoplay = 'false';
});


/* --- Mega menu ---------------------------------------------------------- */

let megaTimer = null;

function closeAllMega(except) {
  document.querySelectorAll('[data-mega]').forEach((m) => {
    if (m === except) return;
    delete m.dataset.open;
    m.querySelector('[data-mega-trigger]')?.setAttribute('aria-expanded', 'false');
    const p = m.querySelector('[data-mega-panel]');
    if (p) p.hidden = true;
  });
}

function openMega(m) {
  closeAllMega(m);
  m.dataset.open = '1';
  m.querySelector('[data-mega-trigger]')?.setAttribute('aria-expanded', 'true');
  const p = m.querySelector('[data-mega-panel]');
  if (p) p.hidden = false;
}

function initMega(m) {
  const trigger = m.querySelector('[data-mega-trigger]');
  if (!trigger) return;

  // Panel gorsellerini onceden cek: panel hidden oldugu surece lazy
  // gorseller hic yuklenmiyor, panel acilinca kartlar bir an bos kaliyordu.
  const warm = () => {
    m.querySelectorAll('[data-mega-panel] img[loading="lazy"]').forEach((img) => {
      img.loading = 'eager';
    });
  };

  // Hover niyeti: imlec menuden gecerken panel acilip kapanmasin
  m.addEventListener('mouseenter', () => {
    warm();
    clearTimeout(megaTimer);
    megaTimer = setTimeout(() => openMega(m), 140);
  });

  // Dokunmatik ve klavyede hover yok; ilk temasta yine onceden cekilir
  trigger.addEventListener('focus', warm);
  m.addEventListener('touchstart', warm, { passive: true });

  m.addEventListener('mouseleave', () => {
    clearTimeout(megaTimer);
    megaTimer = setTimeout(() => closeAllMega(), 180);
  });

  trigger.addEventListener('click', () => {
    if (m.dataset.open) closeAllMega();
    else openMega(m);
  });

  m.addEventListener('focusout', (e) => {
    if (!m.contains(e.relatedTarget)) closeAllMega(m === e.target ? null : undefined);
  });
}

/* --- Mobil surgu -------------------------------------------------------- */

function initDrill(root) {
  const rootLevel = root.querySelector('[data-drill-root]');

  root.querySelectorAll('[data-drill-open]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const sub = root.querySelector(`[data-drill-sub="${btn.dataset.drillOpen}"]`);
      if (!sub) return;
      rootLevel.hidden = true;
      sub.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      sub.querySelector('[data-drill-back]')?.focus();
    });
  });

  root.querySelectorAll('[data-drill-back]').forEach((btn) => {
    btn.addEventListener('click', () => {
      btn.closest('[data-drill-sub]').hidden = true;
      rootLevel.hidden = false;
      root.querySelectorAll('[data-drill-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    });
  });
}


/* --- Filtre acilir kutulari --------------------------------------------- */

function initFbar(bar) {
  const drops = [...bar.querySelectorAll('[data-fdrop]')];

  drops.forEach((d) => {
    d.addEventListener('toggle', () => {
      if (!d.open) return;

      // Ayni anda tek kutu acik kalsin
      drops.forEach((o) => {
        if (o !== d) {
          o.open = false;
          delete o.dataset.flip;
        }
      });

      // Konumu olcup gerekiyorsa saga hizala. Sabit bir kural
      // (ornegin "son iki kutu") az filtrede kutuyu ekran disina itiyor.
      // Mobil akordeonda panel akista oldugu icin flip'e gerek yok.
      delete d.dataset.flip;
      const panel = d.querySelector('.fdrop__panel');
      if (!panel) return;
      const r = panel.getBoundingClientRect();
      if (r.right > document.documentElement.clientWidth - 8) d.dataset.flip = '1';
    });
  });

  // Masaustunde acilir kutu disina tiklayinca kapansin. Mobilde kutular
  // alt sayfa icinde akordeon oldugu icin bu davranis istenmez.
  document.addEventListener('click', (e) => {
    if (bar.contains(e.target)) return;
    drops.forEach((d) => (d.open = false));
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !bar.classList.contains('fsheet-open')) {
      drops.forEach((d) => (d.open = false));
    }
  });

  initFsheet(bar);
}


/* --- Mobil filtre/siralama alt sayfasi ---------------------------------- */

function initFsheet(bar) {
  const sheet = bar.querySelector('[data-fsheet]');
  if (!sheet) return;

  const triggers = [...bar.querySelectorAll('[data-fsheet-open]')];
  const closers = [...bar.querySelectorAll('[data-fsheet-close]')];
  const title = bar.querySelector('[data-fsheet-title]');
  const mq = window.matchMedia('(max-width: 749px)');
  let opener = null;

  const focusables = () =>
    [...sheet.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, [tabindex]:not([tabindex="-1"])')].filter(
      (el) => el.offsetParent !== null
    );

  function open(which, btn) {
    if (!mq.matches) return;
    opener = btn || null;

    // Kip: "sort" ise yalnizca siralama, aksi halde yalnizca filtreler
    sheet.dataset.mode = which === 'sort' ? 'sort' : 'filter';

    if (title && btn) title.textContent = btn.dataset.label || title.textContent;

    // Alt sayfa bir diyalog gibi davranir
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    bar.classList.add('fsheet-open');
    document.body.style.overflow = 'hidden';
    triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
    if (btn) btn.setAttribute('aria-expanded', 'true');

    // Siralamaya girildiyse dogrudan secime odaklan
    const target = which === 'sort' ? sheet.querySelector('#sort') : sheet.querySelector('[data-fsheet-close]');
    (target || sheet).focus?.();
  }

  function close() {
    if (!bar.classList.contains('fsheet-open')) return;
    bar.classList.remove('fsheet-open');
    document.body.style.overflow = '';
    triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));

    // Gecis bitince diyalog rollerini kaldir; masaustunde anlamsizlar
    setTimeout(() => {
      if (bar.classList.contains('fsheet-open')) return;
      sheet.removeAttribute('role');
      sheet.removeAttribute('aria-modal');
    }, 200);

    opener?.focus();
    opener = null;
  }

  triggers.forEach((t) => {
    t.addEventListener('click', () => open(t.dataset.fsheetOpen, t));
  });

  closers.forEach((c) => {
    c.addEventListener('click', close);
  });

  document.addEventListener('keydown', (e) => {
    if (!bar.classList.contains('fsheet-open')) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      close();
      return;
    }

    // Panel icinde Tab dongusu
    if (e.key === 'Tab') {
      const f = focusables();
      if (!f.length) return;
      const first = f[0];
      const last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  // Masaustune gecilirse alt sayfa akista bir bara donusur; acik kalan
  // kilit ve roller temizlenmeli.
  mq.addEventListener('change', (e) => {
    if (!e.matches) close();
  });
}


/* --- Aciklama kirpma ---------------------------------------------------- */

function initClamp(box) {
  const text = box.querySelector('[data-clamp-text]');
  const btn = box.querySelector('[data-clamp-toggle]');
  if (!text || !btn) return;

  const more = btn.textContent.trim();
  const less = btn.dataset.less || 'Daha az göster';

  // Buton yalnizca metin gercekten tasiyorsa anlamli
  const overflows = () => text.scrollHeight - text.clientHeight > 2;
  if (!overflows()) return;
  btn.hidden = false;

  btn.addEventListener('click', () => {
    const open = box.hasAttribute('data-open');
    box.toggleAttribute('data-open', !open);
    btn.textContent = open ? more : less;
    btn.setAttribute('aria-expanded', String(!open));
  });
}


/* --- Sepet satir adedi ------------------------------------------------- */

async function changeLine(li, quantity) {
  const line = Number(li.dataset.line);
  if (!line) return;
  li.dataset.busy = '1';

  try {
    const res = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity }),
    });
    if (!res.ok) throw new Error('cart change failed');

    await updateCartCount();
    await CartDrawer.refresh();
  } catch {
    delete li.dataset.busy;
  }
}

function initQty(root) {
  root.querySelectorAll('[data-qty-step]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const li = btn.closest('[data-line]');
      const input = li?.querySelector('[data-qty-input]');
      if (!input) return;
      const next = Math.max(0, Number(input.value) + Number(btn.dataset.qtyStep));
      changeLine(li, next);
    });
  });

  root.querySelectorAll('[data-qty-input]').forEach((input) => {
    input.addEventListener('change', () => {
      const li = input.closest('[data-line]');
      if (li) changeLine(li, Math.max(0, Number(input.value) || 0));
    });
  });

  root.querySelectorAll('[data-qty-remove]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const li = btn.closest('[data-line]');
      if (li) changeLine(li, 0);
    });
  });
}

/* --- Ürün sayfası ------------------------------------------------------- */

/* Varyant, galeri, adet ve büyütme tek modülde. Fiyat, taksit ve indirim
   metinleri [data-pdp-variants] içinde sunucuda üretilmiş hâlde gelir;
   burada yalnızca yerlerine konur. Para birimini tarayıcıda yeniden
   biçimlendirmek kur/format ayarlarıyla ayrışma riski taşıyor. */
function initPdp(root) {
  const dataEl = root.querySelector('[data-pdp-variants]');
  if (!dataEl) return;

  let variants = [];
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch {
    return;
  }

  const t = root.dataset;
  const q = (sel) => root.querySelector(sel);
  const setText = (sel, value) => {
    const el = q(sel);
    if (el) el.textContent = value;
  };

  const form = q('form.pdp__form');
  const groups = [...root.querySelectorAll('[data-option-group]')];
  const idInput = q('[data-variant-id]');
  const addBtn = q('[data-add-btn]');
  const addText = q('[data-add-text]');
  const wish = q('[data-wishlist]');

  /* Liquid'in form etiketine tireli data-* geçirilemiyor. İşareti burada
     koyuyoruz, AJAX bağlamasını bind() içindeki genel döngü yapıyor. */
  if (form) form.setAttribute('data-cart-form', '');

  /* --- Galeri --- */

  const stage = root.querySelector('.pdp__stage');
  const slides = [...root.querySelectorAll('[data-slide-id]')];
  const orderedIds = slides.map((sl) => sl.dataset.slideId);
  const counter = root.querySelector('[data-gallery-index]');

  const showMedia = (id) => {
    root.querySelectorAll('[data-slide-id]').forEach((sl) => {
      const on = sl.dataset.slideId === String(id);
      sl.hidden = !on;
      // Gizlenen slayttaki video arka planda çalmaya devam etmesin
      if (!on) sl.querySelectorAll('video').forEach((vd) => vd.pause());
    });
    root.querySelectorAll('[data-thumb-id]').forEach((th) => {
      th.setAttribute('aria-current', String(th.dataset.thumbId === String(id)));
    });
    if (counter) {
      const i = orderedIds.indexOf(String(id));
      if (i >= 0) counter.textContent = i + 1;
    }
  };

  root.querySelectorAll('[data-thumb-id]').forEach((th) => {
    th.addEventListener('click', () => showMedia(th.dataset.thumbId));
  });

  /* Mobilde ana görselde parmakla kaydırma: thumbnail'lar küçük, asıl
     jest görselin kendisinde beklenir. Dikey hareket baskınsa sayfa
     kaymasına karışmıyoruz; dinleyici passive kalsın diye engellemiyoruz. */
  if (stage && slides.length > 1) {
    let sx = null;
    let sy = null;
    let swiped = false;

    stage.addEventListener(
      'touchstart',
      (e) => {
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        swiped = false;
      },
      { passive: true }
    );

    stage.addEventListener(
      'touchend',
      (e) => {
        if (sx === null) return;
        const dx = e.changedTouches[0].clientX - sx;
        const dy = e.changedTouches[0].clientY - sy;
        sx = null;
        // Kısa dokunuşu ve dikey kaydırmayı yok say
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        const cur = slides.findIndex((sl) => !sl.hidden);
        if (cur < 0) return;
        const next = dx < 0 ? Math.min(cur + 1, slides.length - 1) : Math.max(cur - 1, 0);
        if (next === cur) return;
        showMedia(orderedIds[next]);
        swiped = true;
      },
      { passive: true }
    );

    // Kaydırmadan sonra tarayıcının ürettiği sahte tıklamayı yut; aksi
    // halde zoom diyaloğu istenmeden açılır. Yakalama evresinde durdurulur.
    stage.addEventListener(
      'click',
      (e) => {
        if (swiped) {
          e.stopPropagation();
          swiped = false;
        }
      },
      true
    );
  }

  const dlg = q('[data-zoom-dialog]');
  if (dlg && typeof dlg.showModal === 'function') {
    const zimg = dlg.querySelector('[data-zoom-img]');
    root.querySelectorAll('[data-zoom-src]').forEach((b) => {
      b.addEventListener('click', () => {
        if (zimg) zimg.src = b.dataset.zoomSrc;
        dlg.showModal();
      });
    });
    dlg.querySelector('[data-zoom-close]')?.addEventListener('click', () => dlg.close());
    dlg.addEventListener('click', (e) => {
      if (e.target === dlg) dlg.close();
    });
  }

  /* --- Adet --- */

  /* Sepet çekmecesi data-qty* ailesini satır adedi için kullanıyor.
     Ürün sayfası kendi ön ekiyle ayrışır, iki mantık birbirine karışmasın. */
  const qtyInput = q('[data-pdp-qty-input]');
  root.querySelectorAll('[data-pdp-qty]').forEach((b) => {
    b.addEventListener('click', () => {
      if (!qtyInput) return;
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + Number(b.dataset.pdpQty));
    });
  });

  /* --- Paylaş --- */

  const shareBtn = q('[data-share]');
  if (shareBtn) {
    shareBtn.addEventListener('click', async () => {
      const payload = { title: document.title, url: window.location.href };
      try {
        if (navigator.share) {
          await navigator.share(payload);
          return;
        }
        await navigator.clipboard.writeText(payload.url);
        shareBtn.dataset.state = 'copied';
        setTimeout(() => delete shareBtn.dataset.state, 1600);
      } catch {
        // Kullanıcı paylaşım sayfasını kapattıysa veya pano izni yoksa sessiz geç
      }
    });
  }

  /* --- Mobil yapışkan satın alma çubuğu --- */

  const abar = q('[data-abar]');
  const abarBtn = q('[data-abar-add]');
  const abarText = abarBtn && abarBtn.querySelector('[data-abar-add-text]');
  const abarPrice = q('[data-abar-price]');
  const abarCompare = q('[data-abar-compare]');
  const abarSaving = q('[data-abar-saving]');
  const abarSavingVal = q('[data-abar-saving-value]');
  const abarImg = q('[data-abar-img]');
  /* .pdp__price sınıfıyla hedeflenir, [data-price] ile değil: favori butonu
     da veri taşıyıcı olarak data-price kullanıyor ve DOM'da daha önce geliyor;
     öznitelik seçici o boş butonu döndürüp fiyatı silerdi. */
  const priceEl = q('.pdp__price');
  const compareEl = q('[data-compare]');
  const savingEl = q('[data-saving]');
  const savingValEl = q('[data-saving-value]');
  const savingLabelEl = q('[data-saving-label]');
  const formMsg = q('[data-form-msg]');
  const hasOptions = groups.length > 0;
  let flashTimer;

  /* Çubuk asıl panelin aynasıdır: fiyat, indirim ve buton durumu buraya
     yansıtılır; AJAX/varyant/stok mantığı asıl formda tek yerde kalır.
     Dört buton durumu:
       • ekle      — varyant seçili ve satılabilir → asıl butonu tetikler
       • ekleniyor — istek uçarken (asıl buton disabled, etiket "Sepete ekle")
       • eklendi   — form mesajı olumlu döndüğünde
       • göster    — çıkmaz kombinasyon/tükendi ama seçilebilir varyant var;
                     ölü tık yerine panele kaydırıp seçenekleri vurgular */
  const syncAbar = () => {
    if (!abar) return;

    if (abarPrice && priceEl) abarPrice.textContent = priceEl.textContent;
    if (abarCompare && compareEl) {
      abarCompare.hidden = compareEl.hidden;
      if (!compareEl.hidden) abarCompare.textContent = compareEl.textContent;
    }
    if (abarSaving && savingEl) {
      abarSaving.hidden = savingEl.hidden;
      if (!savingEl.hidden) {
        if (abarSavingVal && savingValEl) abarSavingVal.textContent = savingValEl.textContent;
        if (savingLabelEl) abarSaving.setAttribute('aria-label', savingLabelEl.textContent);
      }
    }

    if (!abarBtn || !addBtn) return;

    const added = formMsg && !formMsg.hidden && formMsg.dataset.tone === 'ok';
    const busy = addBtn.disabled && addText && addText.textContent === t.i18nAddtocart;

    abar.classList.toggle('is-busy', Boolean(busy && !added));
    abar.classList.toggle('is-added', Boolean(added));

    let mode = 'add';
    let disabled = addBtn.disabled;
    let label = addText ? addText.textContent : '';

    if (added) {
      label = t.i18nAdded || '✓';
      disabled = true;
    } else if (busy) {
      label = t.i18nAdding || label;
      disabled = true;
    } else if (addBtn.disabled && hasOptions) {
      mode = 'choose';
      label = t.i18nViewoptions || label;
      disabled = false;
    }

    abarBtn.dataset.mode = mode;
    abarBtn.disabled = disabled;
    if (abarText) abarText.textContent = label;
  };

  if (abar && abarBtn && addBtn) {
    abarBtn.addEventListener('click', () => {
      /* Seçilecek varyant varken buton ölü tık olmasın: kullanıcıyı
         seçenek paneline kaydır ve bir an vurgula. */
      if (abarBtn.dataset.mode === 'choose') {
        const variantsBox = q('.pdp__variants');
        const panel = variantsBox || q('.pdp__panel');
        (variantsBox || q('.pdp__buy') || panel)?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
        if (panel) {
          clearTimeout(flashTimer);
          panel.classList.remove('pdp__flash');
          void panel.offsetWidth; // reflow: animasyon her tıkta yeniden başlasın
          panel.classList.add('pdp__flash');
          flashTimer = setTimeout(() => panel.classList.remove('pdp__flash'), 1200);
        }
        return;
      }
      if (!addBtn.disabled) addBtn.click();
    });

    /* Asıl "Sepete Ekle" görünürden çıkınca çubuğu getir; çubuk görünürken
       erişilebilirlik ağacına da girsin (gizliyken klavye/okuyucu dışında). */
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) =>
          entries.forEach((en) => {
            const on = !en.isIntersecting;
            abar.classList.toggle('is-on', on);
            abar.setAttribute('aria-hidden', on ? 'false' : 'true');
            abarBtn.tabIndex = on ? 0 : -1;
          }),
        { threshold: 0 }
      );
      io.observe(addBtn);
    }

    /* Ekleme yaşam döngüsünü asıl butonun disabled durumundan ve form
       mesajından oku, çubuğa yansıt: "Ekleniyor…" ve "Sepete eklendi"
       durumları addToCart'a dokunmadan böyle canlanır. */
    if ('MutationObserver' in window) {
      const mo = new MutationObserver(() => syncAbar());
      mo.observe(addBtn, { attributes: true, attributeFilter: ['disabled'] });
      if (formMsg) {
        mo.observe(formMsg, {
          attributes: true,
          attributeFilter: ['hidden', 'data-tone'],
          childList: true,
          characterData: true,
          subtree: true,
        });
      }
    }

    syncAbar();
  }

  /* --- Varyant --- */

  if (!groups.length) return;

  const chosen = () => groups.map((g) => g.querySelector('input:checked')?.value ?? '');

  const match = (opts) => variants.find((vr) => vr.options.every((o, i) => o === opts[i]));

  /* Seçili diğer opsiyonlar sabitken bu değerin satılabilir bir karşılığı
     var mı? Yoksa pill tükendi olarak işaretlenir. Girdi disabled
     yapılmıyor: kullanıcı çıkmaza girdiğinde geri dönebilmeli. */
  const paintOptions = () => {
    const now = chosen();
    groups.forEach((g, idx) => {
      g.querySelectorAll('.pill').forEach((pill) => {
        const input = pill.querySelector('input');
        if (!input) return;
        const ok = variants.some(
          (vr) =>
            vr.available &&
            vr.options.every((o, i) => (i === idx ? o === input.value : o === now[i]))
        );
        pill.toggleAttribute('data-soldout', !ok);
        // Görsel üstü çizgi ekran okuyucuya geçmiyor, durumu metne taşı
        input.setAttribute('aria-label', ok ? input.value : `${input.value} — ${t.i18nSoldout}`);
      });
    });
  };

  const apply = (vr) => {
    setText('.pdp__price', vr.priceText);

    const cmp = q('[data-compare]');
    if (cmp) {
      cmp.hidden = !vr.compareText;
      if (vr.compareText) cmp.textContent = vr.compareText;
    }

    const sv = q('[data-saving]');
    if (sv) {
      sv.hidden = vr.saving <= 0;
      setText('[data-saving-value]', vr.saving);
      setText('[data-saving-label]', vr.savingLabel);
    }

    if (vr.installment) setText('[data-installment]', vr.installment);

    const dot = q('[data-stock-dot]');
    if (dot) dot.className = `dot ${vr.available ? 'dot--ok' : 'dot--out'}`;

    const low = Number(t.lowThreshold) || 0;
    const stock = q('[data-stock-text]');
    if (stock) {
      if (!vr.available) stock.textContent = t.i18nSoldout;
      else if (low > 0 && vr.inventory > 0 && vr.inventory <= low)
        stock.textContent = t.i18nLowstock.replace('__n__', vr.inventory);
      else stock.textContent = t.i18nInstock;
    }

    const deliv = q('[data-stock-delivery]');
    if (deliv) deliv.hidden = !vr.available;

    const skuRow = q('[data-sku-row]');
    if (skuRow) {
      skuRow.hidden = !vr.sku;
      setText('[data-sku]', vr.sku || '');
    }

    if (idInput) idInput.value = vr.id;
    if (addBtn) addBtn.disabled = !vr.available;
    if (addText) addText.textContent = vr.available ? t.i18nAddtocart : t.i18nSoldout;

    // Favori kaydı seçili varyantın fiyatıyla yazılsın
    if (wish) wish.dataset.price = vr.price;

    if (vr.mediaId) {
      showMedia(vr.mediaId);
      // Yapışkan çubuğun küçük görselini de seçili varyanta çevir; kaynak
      // olarak galeri küçük görseli kullanılır (ek görsel URL'si taşınmaz).
      if (abarImg) {
        const thumb = root.querySelector(`[data-thumb-id="${vr.mediaId}"] img`);
        if (thumb) abarImg.src = thumb.currentSrc || thumb.src;
      }
    }

    // Bağlantı paylaşılabilir kalsın
    const url = new URL(window.location.href);
    url.searchParams.set('variant', vr.id);
    window.history.replaceState({}, '', url);

    syncAbar();
  };

  groups.forEach((g) =>
    g.addEventListener('change', () => {
      paintOptions();
      const vr = match(chosen());
      if (!vr) {
        if (idInput) idInput.value = '';
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = t.i18nUnavailable;
        syncAbar();
        return;
      }
      apply(vr);
    })
  );

  // İlk çizimde yalnızca uygunluk işaretlenir; sunucudan gelen durum zaten doğru
  // ve kullanıcı dokunmadan adres çubuğunu değiştirmek istemiyoruz.
  paintOptions();
}

/* --- Teslimat konumu ---------------------------------------------------- */

const LOC_KEY = 'yk-location';

/* Türkçe arama: "istanbul", "İSTANBUL" ve "Istanbul" aynı sonucu vermeli.
   toLowerCase() tek başına yetmiyor çünkü I/İ eşlemesi Türkçede özeldir;
   harfleri önce ASCII karşılıklarına indiriyoruz. */
const TR_CHARS = {
  İ: 'i', I: 'i', ı: 'i',
  Ş: 's', ş: 's',
  Ğ: 'g', ğ: 'g',
  Ü: 'u', ü: 'u',
  Ö: 'o', ö: 'o',
  Ç: 'c', ç: 'c',
  Â: 'a', â: 'a',
  Î: 'i', î: 'i',
  Û: 'u', û: 'u',
};

const trNorm = (s) => (s || '').replace(/[İIıŞşĞğÜüÖöÇçÂâÎîÛû]/g, (c) => TR_CHARS[c]).toLowerCase();

/* Kayıt {il, ilce} biçiminde. ilce boşsa "tüm ilçeler" seçilmiş demektir. */
const Location = {
  get() {
    try {
      const raw = JSON.parse(localStorage.getItem(LOC_KEY) || 'null');
      return raw && typeof raw === 'object' && raw.il ? raw : null;
    } catch {
      return null;
    }
  },

  set(value) {
    try {
      localStorage.setItem(LOC_KEY, JSON.stringify(value));
    } catch {
      // Gizli sekmede kota hatası verebilir; seçim o oturumda ekranda kalır.
    }
  },

  clear() {
    try {
      localStorage.removeItem(LOC_KEY);
    } catch {
      // yoksayılır
    }
  },

  label(value) {
    if (!value) return '';
    return value.ilce ? `${value.il}, ${value.ilce}` : value.il;
  },
};

/* Başlıktaki etiketi ve panelin "temizle" satırını kayıtla eşitler. */
function paintLocation() {
  const saved = Location.get();

  document.querySelectorAll('[data-location-open]').forEach((btn) => {
    const label = btn.querySelector('[data-location-label]');
    if (!label) return;
    label.textContent = saved ? Location.label(saved) : btn.dataset.locationDefault || label.textContent;
  });

  document.querySelectorAll('[data-location-foot]').forEach((foot) => {
    foot.hidden = !saved;
  });
}

const LocationPicker = {
  data: null, // [{ il, ilceler }]
  city: null, // ikinci adımda seçili il
  pending: null,

  el: () => document.querySelector('[data-location-panel]'),

  /* Liste yalnızca bir kez indirilir; aynı anda iki istek açılmasın diye
     bekleyen söz saklanır. */
  load(panel) {
    if (this.data) return Promise.resolve(this.data);
    if (this.pending) return this.pending;

    this.pending = fetch(panel.dataset.src)
      .then((res) => {
        if (!res.ok) throw new Error('locations');
        return res.json();
      })
      .then((json) => {
        this.data = json;
        return json;
      })
      .catch(() => null)
      .finally(() => {
        this.pending = null;
      });

    return this.pending;
  },

  // Panel dışındaki her şey klavye ve ekran okuyucudan çıkarılır.
  inertBackground(on) {
    const panel = this.el();
    [...document.body.children].forEach((el) => {
      if (el === panel) return;
      el.inert = on;
    });
  },

  open() {
    const panel = this.el();
    if (!panel) return;

    panel.hidden = false;
    // Zorunlu reflow: geçişin başlangıç durumu kaydedilsin.
    void panel.offsetWidth;
    panel.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    this.inertBackground(true);
    document.querySelectorAll('[data-location-open]').forEach((b) => {
      b.setAttribute('aria-expanded', 'true');
    });

    // Her açılışta il listesinden başlanır.
    this.city = null;
    const search = panel.querySelector('[data-location-search]');
    if (search) search.value = '';

    this.load(panel).then((data) => {
      const err = panel.querySelector('[data-location-error]');
      if (err) err.hidden = Boolean(data);
      this.render();
      search?.focus();
    });
  },

  close() {
    const panel = this.el();
    if (!panel || panel.hidden) return;

    panel.classList.remove('is-open');
    document.body.style.overflow = '';
    this.inertBackground(false);
    document.querySelectorAll('[data-location-open]').forEach((b) => {
      b.setAttribute('aria-expanded', 'false');
    });
    document.querySelector('[data-location-open]')?.focus();

    setTimeout(() => {
      panel.hidden = true;
    }, 200);
  },

  back() {
    const panel = this.el();
    if (!panel) return;
    this.city = null;
    const search = panel.querySelector('[data-location-search]');
    if (search) search.value = '';
    this.render();
    search?.focus();
  },

  /* İlk adımda il, ikinci adımda ilçe seçilir. */
  pick(name) {
    const panel = this.el();
    if (!panel) return;

    if (!this.city) {
      this.city = name;
      const search = panel.querySelector('[data-location-search]');
      if (search) search.value = '';
      this.render();
      search?.focus();
      return;
    }

    const all = panel.dataset.tAll;
    Location.set({ il: this.city, ilce: name === all ? '' : name });
    paintLocation();
    this.close();
  },

  render() {
    const panel = this.el();
    if (!panel) return;

    const list = panel.querySelector('[data-location-list]');
    const step = panel.querySelector('[data-location-step]');
    const back = panel.querySelector('[data-location-back]');
    const search = panel.querySelector('[data-location-search]');
    const empty = panel.querySelector('[data-location-empty]');
    if (!list) return;

    const inDistricts = Boolean(this.city);
    const all = panel.dataset.tAll;
    const saved = Location.get();

    if (step) step.textContent = inDistricts ? panel.dataset.tDistrict : panel.dataset.tCity;
    if (back) back.hidden = !inDistricts;
    if (search) search.placeholder = inDistricts ? panel.dataset.tSearchDistrict : panel.dataset.tSearchCity;

    list.textContent = '';

    if (!this.data) {
      if (empty) empty.hidden = true;
      return;
    }

    const source = inDistricts
      ? (this.data.find((c) => c.il === this.city)?.ilceler || [])
      : this.data.map((c) => c.il);

    const q = trNorm(search?.value || '');
    const rows = q ? source.filter((name) => trNorm(name).includes(q)) : source;

    // "Tüm ilçeler" bir ilçe adı değil, aramayla elenmemeli.
    const shown = inDistricts ? [all, ...rows] : rows;

    const chevron = panel.querySelector('[data-location-chevron]');
    const frag = document.createDocumentFragment();

    shown.forEach((name) => {
      const row = document.createElement('button');
      row.type = 'button';
      row.className = 'loc__row';

      const text = document.createElement('span');
      text.textContent = name;
      row.appendChild(text);

      // İl satırı bir adım daha açar, ilçe satırı seçimi bitirir.
      if (!inDistricts && chevron) row.appendChild(chevron.content.cloneNode(true));

      const active = inDistricts
        ? saved?.il === this.city && (saved.ilce || all) === name
        : saved?.il === name;
      if (active) row.classList.add('loc__row--active');

      row.addEventListener('click', () => this.pick(name));
      frag.appendChild(row);
    });

    list.appendChild(frag);
    if (empty) empty.hidden = shown.length > 0;
  },

  // Panel içinde Tab döngüsü
  trap(e) {
    const panel = this.el();
    if (!panel || panel.hidden || e.key !== 'Tab') return;
    const f = [...panel.querySelectorAll('button:not([disabled]), input, [tabindex]:not([tabindex="-1"])')].filter(
      (el) => el.offsetParent !== null
    );
    if (!f.length) return;
    const first = f[0];
    const last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  },
};

/* Panel başlık bölümünün içinde üretilir ama <body> altına taşınır:
   açıkken arka plan inert yapılıyor ve panel <header> içinde kalsaydı
   kendisi de erişilemez hale gelirdi. */
function hoistLocationPanel(root) {
  const panel = root.querySelector?.('[data-location-panel]');
  if (!panel || panel.parentElement === document.body) return;

  // Bölüm yeniden render edildiğinde eski kopya geride kalmasın.
  document.querySelectorAll('body > [data-location-panel]').forEach((old) => old.remove());
  document.body.appendChild(panel);

  panel.querySelectorAll('[data-location-close]').forEach((b) => {
    b.addEventListener('click', () => LocationPicker.close());
  });

  panel.querySelector('[data-location-back]')?.addEventListener('click', () => LocationPicker.back());

  panel.querySelector('[data-location-clear]')?.addEventListener('click', () => {
    Location.clear();
    paintLocation();
    LocationPicker.render();
  });

  const search = panel.querySelector('[data-location-search]');
  search?.addEventListener('input', () => LocationPicker.render());
  search?.addEventListener('keydown', (e) => {
    // Enter aramada ilk sonucu seçer, formsuz panelde beklenen davranış bu.
    if (e.key !== 'Enter') return;
    e.preventDefault();
    panel.querySelector('.loc__row')?.click();
  });
}

/* --- Tür şeridi --------------------------------------------------------- */

/* Seçili tür şeridin ortasına alınır. Sayfa filtreyle yeniden yüklendiğinde
   şerit başa sarıyordu; Xenon gibi 20'ye yakın türü olan koleksiyonlarda
   seçili tür ekranın dışında kalıyor ve kullanıcı neyi seçtiğini göremiyordu.

   scrollIntoView kullanılmadı: yatay şeridi hizalarken sayfayı da dikey
   kaydırıp başlığı ekrandan çıkarıyor. Burada yalnızca şeridin kendi
   scrollLeft'i değişiyor, sayfa yerinde kalıyor. */
function centerActiveType(rail) {
  const active = rail.querySelector('[aria-current="true"]');
  if (!active) return;

  // getBoundingClientRect: offsetLeft, offsetParent'a bağlı olduğu için
  // araya konumlanmış bir sarmalayıcı girdiğinde yanlış sonuç veriyor.
  const railBox = rail.getBoundingClientRect();
  const box = active.getBoundingClientRect();
  rail.scrollLeft += box.left - railBox.left - (railBox.width - box.width) / 2;
}

/* --- Mobil menü --------------------------------------------------------- */

/* Sepet çekmecesiyle aynı kurallar: gövde kaydırması kilitlenir, arka plan
   inert olur, odak panelin içinde döner. */
const MobileNav = {
  el: () => document.querySelector('[data-mobile-nav]'),

  open() {
    const d = this.el();
    if (!d) return;
    d.hidden = false;
    // Zorunlu reflow; CartDrawer'daki ile aynı gerekçe, sekme arka
    // plandayken rAF hiç çalışmadığından panel ekran dışında kalıyor.
    void d.offsetWidth;
    d.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    document.querySelectorAll('body > header, body > main, body > footer').forEach((el) => {
      el.inert = true;
    });
    document.querySelectorAll('[data-menu-toggle]').forEach((b) =>
      b.setAttribute('aria-expanded', 'true')
    );
    d.querySelector('[data-menu-close]')?.focus();
  },

  close() {
    const d = this.el();
    if (!d || d.hidden) return;
    d.classList.remove('is-open');
    document.body.style.overflow = '';
    document.querySelectorAll('body > header, body > main, body > footer').forEach((el) => {
      el.inert = false;
    });
    document.querySelectorAll('[data-menu-toggle]').forEach((b) =>
      b.setAttribute('aria-expanded', 'false')
    );
    document.querySelector('[data-menu-toggle]')?.focus();
    // Panel geçişi bitmeden hidden verilirse kapanış animasyonu yutulur
    setTimeout(() => {
      d.hidden = true;
    }, 280);
  },

  trap(e) {
    const d = this.el();
    if (!d || d.hidden || e.key !== 'Tab') return;
    const f = [
      ...d.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'),
    ].filter((el) => el.offsetParent !== null);
    if (!f.length) return;
    const first = f[0];
    const last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  },
};

/* Panel body'ye taşınır: .hdr üzerindeki backdrop-filter içerideki
   position:fixed öğeler için kapsayıcı blok yaratıyor, panel viewport
   yerine header'a göre konumlanıyordu. Konum seçici de aynı yolu izliyor.

   Taşındıktan sonra panel artık bölümün içinde olmadığı için sürgü ve
   kapatma düğmeleri burada bağlanır; bind() içindeki genel döngüler
   bölüm yeniden render edildiğinde onu bulamaz. */
function hoistMobileNav(root) {
  const panel = root.querySelector?.('[data-mobile-nav]');
  if (!panel || panel.parentElement === document.body) return;

  document.querySelectorAll('body > [data-mobile-nav]').forEach((old) => old.remove());
  document.body.appendChild(panel);

  panel.querySelectorAll('[data-menu-close]').forEach((b) => {
    b.addEventListener('click', () => MobileNav.close());
  });

  panel.querySelectorAll('[data-drill]').forEach((d) => {
    if (d.dataset.bound) return;
    d.dataset.bound = '1';
    initDrill(d);
  });
}

  /* --- Bağlama ---------------------------------------------------------- */

  /* --- Canlı arama ------------------------------------------------------- */

  /* Header'daki arama kutusuna yazarken Shopify Predictive Search'ten
     (bölüm render modu) ürün sonuçlarını çeker. Sonuç HTML'i Liquid'de
     üretilir (predictive-search.liquid), burada yalnızca panele taşınır;
     i18n ve para biçimi tema ile birebir aynı kalır. */
  const PredictiveSearch = {
    MIN: 2, // en az bu kadar karakterle istek atılır
    DELAY: 280, // her tuşta değil, yazma durunca istek atılır
    timer: null,
    controller: null,
    active: -1, // klavyeyle seçili satırın indisi (-1: yok)
    globalBound: false,

    input: (form) => form.querySelector('[data-predictive-input]'),
    panel: (form) => form.querySelector('[data-predictive-results]'),
    status: (form) => form.querySelector('[data-predictive-status]'),
    options: (form) => [...form.querySelectorAll('[data-predictive-option]')],

    init(root) {
      (root || document).querySelectorAll('[data-predictive-search]').forEach((form) => {
        if (form.dataset.bound) return;
        form.dataset.bound = '1';
        const input = this.input(form);
        const panel = this.panel(form);
        if (!input || !panel) return;

        input.addEventListener('input', () => this.onInput(form));
        input.addEventListener('focus', () => {
          // Zaten sonucu olan sorguya geri dönülünce paneli yeniden aç.
          if (input.value.trim().length >= this.MIN && panel.dataset.term === input.value.trim()) {
            this.open(form);
          }
        });
        input.addEventListener('keydown', (e) => this.onKeydown(e, form));
        // Enter/buton ile gerçek arama sayfasına gidilirken panel kapanır.
        form.addEventListener('submit', () => this.close(form));
      });

      // Dışarı tıklama tüm panelleri kapatır — belge düzeyinde bir kez.
      if (!this.globalBound) {
        this.globalBound = true;
        document.addEventListener('click', (e) => {
          document.querySelectorAll('[data-predictive-search]').forEach((form) => {
            if (!form.contains(e.target)) this.close(form);
          });
        });
      }
    },

    onInput(form) {
      const q = this.input(form).value.trim();
      clearTimeout(this.timer);
      this.active = -1;
      if (q.length < this.MIN) {
        this.close(form);
        return;
      }
      this.timer = setTimeout(() => this.search(form, q), this.DELAY);
    },

    async search(form, q) {
      const panel = this.panel(form);
      // Önceki istek hâlâ uçuyorsa iptal et: geç dönen eski yanıt yenisini ezmesin.
      this.controller?.abort();
      this.controller = new AbortController();

      const root = window.Shopify.routes.root;
      const url =
        `${root}search/suggest?q=${encodeURIComponent(q)}` +
        `&section_id=predictive-search` +
        `&resources[type]=product&resources[limit]=8`;

      this.setLoading(form);
      try {
        const res = await fetch(url, { signal: this.controller.signal });
        if (!res.ok) throw new Error('bad status');
        const text = await res.text();
        const inner = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('[data-predictive-inner]');
        panel.innerHTML = inner ? inner.innerHTML : '';
        panel.dataset.term = q;
        panel.removeAttribute('aria-busy');
        this.active = -1;
        this.open(form);
        this.announce(form);
      } catch (e) {
        if (e.name === 'AbortError') return; // yenisi geldi, sessizce bırak
        panel.innerHTML = `<p class="predictive__state" role="alert">${panel.dataset.tError || ''}</p>`;
        panel.removeAttribute('aria-busy');
        this.open(form);
      }
    },

    setLoading(form) {
      const panel = this.panel(form);
      const status = this.status(form);
      const text = panel.dataset.tLoading || '';
      panel.innerHTML = `<p class="predictive__state" aria-hidden="true">${text}</p>`;
      panel.setAttribute('aria-busy', 'true');
      if (status) status.textContent = text;
      this.open(form);
    },

    announce(form) {
      const status = this.status(form);
      if (!status) return;
      const panel = this.panel(form);
      // Çoğul ekli sayı ve boş-durum metni Liquid'den geldiği gibi okunur.
      const summary =
        panel.querySelector('[data-predictive-summary]')?.textContent ||
        panel.querySelector('[data-predictive-msg]')?.textContent ||
        '';
      status.textContent = summary.trim();
    },

    onKeydown(e, form) {
      const panel = this.panel(form);
      const input = this.input(form);
      const open = !panel.hidden;

      if (e.key === 'Escape') {
        if (open) {
          e.preventDefault();
          this.close(form);
        }
        return;
      }

      const items = open ? this.options(form) : [];
      if (!items.length) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        this.active = (this.active + 1) % items.length;
        this.paintActive(form, items);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        this.active = (this.active - 1 + items.length) % items.length;
        this.paintActive(form, items);
      } else if (e.key === 'Enter') {
        // Bir satır seçiliyse doğrudan ürüne git; değilse formun normal
        // gönderimi (tüm sonuçlar sayfası) çalışsın.
        if (this.active >= 0 && items[this.active]) {
          e.preventDefault();
          window.location.href = items[this.active].href;
        }
      }
    },

    paintActive(form, items) {
      const input = this.input(form);
      items.forEach((el, i) => {
        const on = i === this.active;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) {
          input.setAttribute('aria-activedescendant', el.id);
          el.scrollIntoView({ block: 'nearest' });
        }
      });
      if (this.active < 0) input.removeAttribute('aria-activedescendant');
    },

    open(form) {
      this.panel(form).hidden = false;
      this.input(form).setAttribute('aria-expanded', 'true');
    },

    close(form) {
      const panel = this.panel(form);
      const input = this.input(form);
      panel.hidden = true;
      panel.removeAttribute('aria-busy');
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      this.active = -1;
    },

    closeAll() {
      document.querySelectorAll('[data-predictive-search]').forEach((f) => this.close(f));
    },
  };

  function bind(root) {
    refreshDeliveryLabels(root);
    PredictiveSearch.init(root);
    hoistLocationPanel(root);
    hoistMobileNav(root);

    /* Formu data-cart-form ile işaretlediği için aşağıdaki sepet
       döngüsünden önce çalışmalı. */
    root.querySelectorAll('[data-pdp]').forEach((p) => {
      if (p.dataset.bound) return;
      p.dataset.bound = '1';
      initPdp(p);
    });

    root.querySelectorAll('[data-recommendations]').forEach((r) => {
      if (r.dataset.bound) return;
      r.dataset.bound = '1';
      initRecommendations(r);
    });

    root.querySelectorAll('[data-types-rail]').forEach((r) => {
      if (r.dataset.bound) return;
      r.dataset.bound = '1';
      centerActiveType(r);
    });

    root.querySelectorAll('[data-carousel]').forEach((c) => {
      if (c.dataset.bound) return;
      c.dataset.bound = '1';
      initCarousel(c);
    });

    root.querySelectorAll('[data-cart-drawer]').forEach((d) => {
      if (d.dataset.bound) return;
      d.dataset.bound = '1';
      initQty(d);
    });

    root.querySelectorAll('[data-clamp]').forEach((c) => {
      if (c.dataset.bound) return;
      c.dataset.bound = '1';
      initClamp(c);
    });

    root.querySelectorAll('[data-fbar]').forEach((b) => {
      if (b.dataset.bound) return;
      b.dataset.bound = '1';
      initFbar(b);
    });

    root.querySelectorAll('[data-mega]').forEach((m) => {
      if (m.dataset.bound) return;
      m.dataset.bound = '1';
      initMega(m);
    });

    root.querySelectorAll('[data-drill]').forEach((d) => {
      if (d.dataset.bound) return;
      d.dataset.bound = '1';
      initDrill(d);
    });

    root.querySelectorAll('[data-hero]').forEach((h) => {
      if (h.dataset.bound) return;
      h.dataset.bound = '1';
      initHero(h);
    });

    root.querySelectorAll('[data-wishlist]').forEach((b) => {
      if (b.dataset.bound) return;
      b.dataset.bound = '1';
      b.addEventListener('click', (e) => {
        e.preventDefault();
        Wishlist.toggle({
          id: b.dataset.wishlist,
          handle: b.dataset.handle,
          url: b.dataset.url,
          title: b.dataset.title,
          vendor: b.dataset.vendor,
          price: Number(b.dataset.price),
          image: b.dataset.image,
        });
        syncLists();
        renderWishlist();
      });
    });

    root.querySelectorAll('[data-wishlist-remove]').forEach((b) => {
      if (b.dataset.bound) return;
      b.dataset.bound = '1';
      b.addEventListener('click', () => {
        Wishlist.remove(b.dataset.wishlistRemove);
        syncLists();
        renderWishlist();
      });
    });

    root.querySelectorAll('[data-wishlist-clear]').forEach((b) => {
      if (b.dataset.bound) return;
      b.dataset.bound = '1';
      b.addEventListener('click', () => {
        Wishlist.clear();
        syncLists();
        renderWishlist();
      });
    });

    root.querySelectorAll('form[data-cart-form]').forEach((form) => {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const btn = form.querySelector('button[type="submit"]');
        if (btn) addToCart(form, btn);
      });
    });

    root.querySelectorAll('[data-cart-open]').forEach((b) => {
      if (b.dataset.bound) return;
      b.dataset.bound = '1';
      b.addEventListener('click', (e) => {
        if (document.body.dataset.cartType !== 'drawer') return;
        e.preventDefault();
        CartDrawer.refresh().then(() => CartDrawer.open());
      });
    });

    root.querySelectorAll('[data-drawer-close], [data-drawer-overlay]').forEach((b) => {
      if (b.dataset.bound) return;
      b.dataset.bound = '1';
      b.addEventListener('click', () => CartDrawer.close());
    });

    root.querySelectorAll('[data-location-open]').forEach((b) => {
      if (b.dataset.bound) return;
      b.dataset.bound = '1';
      b.addEventListener('click', () => LocationPicker.open());
    });

    root.querySelectorAll('[data-menu-toggle]').forEach((b) => {
      if (b.dataset.bound) return;
      b.dataset.bound = '1';
      b.addEventListener('click', () => {
        const nav = MobileNav.el();
        if (!nav) return;
        if (nav.hidden) MobileNav.open();
        else MobileNav.close();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    bind(document);
    syncLists();
    paintLocation();
    recordRecentlyViewed();
    renderRecentlyViewed();
    renderWishlist();
    refreshWishlist();
  });
  document.addEventListener('shopify:section:load', (e) => {
    bind(e.target);
    syncLists();
    paintLocation();
    renderRecentlyViewed();
    renderWishlist();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      CartDrawer.close();
      LocationPicker.close();
      MobileNav.close();
      closeAllMega();
      PredictiveSearch.closeAll();
    }
    CartDrawer.trap(e);
    LocationPicker.trap(e);
    MobileNav.trap(e);
  });
})();
